import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { Container } from './AlertPortal.style';

const AlertPortal = () => {
    return <Container hideProgressBar closeOnClick={false} icon={false} closeButton={false} />;
};

export default AlertPortal;
